export default {
  common: {
    loading: "جارٍ التحميل...",
  },
  header: {
    openMenu: "فتح القائمة",
    home: "الرئيسية",
    language: "اللغة",
    searchPlaceholder: "ابحث عن صفحة...",
    searchLabel: "ابحث عن صفحة",
    noResult: "لا توجد نتائج",
    notifications: "الإشعارات",
    notificationsUnread: "الإشعارات، {count} غير مقروءة",
    markAllRead: "تعليم الكل كمقروء",
    onlyUnread: "غير المقروءة فقط",
    loadMore: "تحميل المزيد",
    viewAllNotifications: "عرض كل الإشعارات",
    noNotifications: "لا توجد إشعارات",
    onlineAccount: "الحساب متصل",
    myAccount: "حسابي",
    myProfile: "ملفي الشخصي",
    profile: "الملف الشخصي",
    settings: "الإعدادات",
    logout: "تسجيل الخروج",
    roleAdmin: "مسؤول",
    roleClient: "عميل",
    roleDriver: "عامل التوصيل",
    roleZoneManager: "مسؤول المنطقة",
    justNow: "الآن",
    minutesAgo: "منذ {n} دقيقة",
    hoursAgo: "منذ {n} ساعة",
  },
  theme: {
    enableLight: "تفعيل الوضع الفاتح",
    enableDark: "تفعيل الوضع الداكن",
    light: "الوضع الفاتح",
    dark: "الوضع الداكن",
  },
  sidebar: {
    mainNav: "التنقل الرئيسي",
    mainMenu: "القائمة الرئيسية",
    closeMenu: "إغلاق القائمة",
    loadingMenu: "جارٍ تحميل القائمة",
  },
  menu: {
    dashboard: "لوحة التحكم",
    trackingDrivers: "مواقع عمال التوصيل",
    parcels: "الطرود",
    parcelsList: "قائمة الطرود",
    newParcels: "طرود جديدة",
    addParcel: "طرد جديد",
    inventory: "المخزون",
    productsList: "قائمة المنتجات",
    stockParcels: "طرود المخزون",
    deliveryNotes: "وصولات التسليم",
    deliveryStockNotes: "وصولات تسليم المخزون",
    packingStation: "التحضير والتغليف",
    parcelReception: "استلام الطرود",
    sentNotes: "وصولات الإرسال",
    distributionNotes: "وصولات التوزيع",
    driverCheck: "متابعة عامل التوصيل",
    driverInvoices: "فواتير عمال التوصيل",
    zoneInvoices: "فواتير المناطق",
    returnNotes: "وصولات الإرجاع",
    zoneReturns: "مرتجعات المناطق",
    clientReturns: "مرتجعات العملاء",
    clientInvoices: "فواتير العملاء",
    invoicesList: "قائمة الفواتير",
    newInvoice: "فاتورة جديدة",
    transfers: "التحويلات",
    refunds: "الاستردادات",
    customers: "العملاء",
    customersList: "قائمة العملاء",
    newCustomers: "عملاء جدد",
    verificationCenter: "مركز التحقق",
    ribRequests: "طلبات تغيير RIB",
    phoneRequests: "طلبات تغيير الهاتف",
    claims: "الشكايات",
    exchanges: "الاستبدال",
    driverReturnsFollowup: "تتبع مرتجعات عمال التوصيل",
    parcelFollowups: "طرود للمتابعة",
    pickup: "الاستلام من العميل",
    pickupNotes: "وصولات الاستلام",
    pickupRequests: "طلبات الاستلام",
    users: "المستخدمون",
    usersList: "قائمة المستخدمين",
    newDrivers: "عمال توصيل جدد",
    driversStatus: "حالة عمال التوصيل",
    expenses: "المصاريف",
    carrierInvoices: "فواتير الناقلين",
    transport: "النقل",
    transportsList: "الناقلون",
    settings: "الإعدادات",
    profile: "الملف الشخصي",
    general: "عام",
    zones: "المناطق",
    pricePacks: "باقات الأسعار",
    cities: "المدن",
    agencies: "الوكالات",
    whatsapp: "واتساب",
    ads: "الإعلانات",
    blackList: "القائمة السوداء",
  },
  pages: {
    addCustomer: "إضافة عميل",
    addUser: "إضافة مستخدم",
    pendingDrivers: "عمال توصيل في الانتظار",
    pickups: "عمليات الاستلام",
    receptionNotes: "وصولات الاستقبال",
    driverPaymentNotes: "وصولات أداء عمال التوصيل",
    zonePaymentNotes: "وصولات أداء المناطق",
    invoices: "الفواتير",
    stockProducts: "منتجات المخزون",
    verifications: "عمليات التحقق",
    accountSettings: "إعدادات الحساب",
    statuses: "الحالات",
    clientTypes: "أنواع العملاء",
    banks: "البنوك",
    transports: "الناقلون",
    trackingDrivers: "مواقع عمال التوصيل",
    refundRequests: "طلبات الاسترداد",
    pointageNotes: "وصولات الحضور",
    addPointage: "إضافة وصل حضور",
    externDeliveryNotes: "وصولات التسليم الخارجية",
    deliveryProviders: "مزودو التوصيل",
    socialLinks: "روابط التواصل الاجتماعي",
    driverApiDocs: "وثائق واجهة برمجة عامل التوصيل",
    addProduct: "إضافة منتج",
    addDeliveryStockNote: "إضافة وصل تسليم المخزون",
    addReceptionNote: "إضافة وصل استقبال",
    addSentNote: "إضافة وصل إرسال",
    addGlobalSentNote: "إضافة وصل إرسال شامل",
    addDistributionNote: "إضافة وصل توزيع",
    addDriverPayment: "إضافة وصل أداء لعامل التوصيل",
    addZonePayment: "إضافة وصل أداء للمنطقة",
    addClientReturn: "إضافة وصل إرجاع للعميل",
    addZoneReturn: "إضافة وصل إرجاع للمنطقة",
    addInvoice: "إضافة فاتورة",
    addVirement: "إضافة تحويل",
    addExpense: "إضافة مصروف",
  },
};
